
import Icon, { iconColor, iconTypes } from "../../../common/components/Icon.jsx";

import DropDownList from "../../../common/components/DropDownList.jsx";
import LabelField from "../../../common/components/LabelField.jsx";
import {Localization} from "../../../common/util/localization.jsx";
import PropTypes from "prop-types";
import React from "react";
import { connect } from "react-redux";

const mapStateToProps = () => {
    return (state) => ({
        productQuery: state.productQuery,
    });
};
const mapDispatchToProps = {
};

/**
 * Creates a compunents, with tools the change the filter
 * @param {props} object
 * @returns {node}
 */
function FilterComponent({productQuery, localization, onEdit, setDropDown}) {

    /**
     * Clears the filter
     * @returns {*}
     */
    function onClickClearFilter() {
        onEdit({
            ProductGroupId: null,
            SupplierId: null,
            SortingColumn: null,
        });
    }

    const prdGroupOptions = [
        {
            value: undefined,
            label: "-",
        },
        ...(productQuery && productQuery.productGroups && productQuery.productGroups.map( (item) => {
            return {
                value: item.productGroupId,
                label: item.productGroupName,
            };
        }) || []),
    ];
    const supplierGroupOptions = [
        {
            value: undefined,
            label: "-",
        },
        ...(productQuery && productQuery.productSuppliers && productQuery.productSuppliers.map( (item) => {
            return {
                value: item.supplierId,
                label: item.supplierName,
            };
        }) || []),
    ];

    const isFilterSelected = productQuery.filter.ProductGroupId!=null || productQuery.filter.SupplierId!=null;

    return (
        <div className="filter-spacing">
            <div className="filter-label">
                <LabelField label={localization.text("filter","productGroup")}/>
            </div>
            <DropDownList options={prdGroupOptions} placeholder={"-"} onEdit={onEdit} source={productQuery.filter} property={"ProductGroupId"} setDropDown={setDropDown}/>
            <div className="filter-label">
                <LabelField label={localization.text("filter","supplierName")}/>
            </div>
            <DropDownList options={supplierGroupOptions} placeholder="-" onEdit={onEdit} source={productQuery.filter} property={"SupplierId"} setDropDown={setDropDown}/>
            { isFilterSelected && (
                <div className="filter-button">
                    <button className="btn primary icon" onClick={onClickClearFilter}><Icon type={iconTypes.x} color={iconColor.red} />{localization.text("filter","clearFilter")}</button>
                </div>
            )}
        </div>
    );
}

FilterComponent.propTypes = {
    localization: Localization.propTypes.isRequired,
    productQuery: PropTypes.object.isRequired,
    onEdit: PropTypes.func.isRequired,
    setDropDown: PropTypes.func.isRequired,
};

export default connect(mapStateToProps,mapDispatchToProps)(FilterComponent);